export default __webpack_public_path__ + "static/accents-icons-light-31ac9fa5bc3f5739446bc9ad52a8be6190361e72556f428a7bd6f30a123e02bd.png";